import React, { useContext, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";
import {  getAllCountries } from "../../APIs/SettingRequests";
import { LabelFieldComponent } from "../../components/fields";
import CountriesTableComponent from "../../components/tables/CountriesTableComponent";
import { PaginationComponent } from "../../components";
import PulseLoader from "react-spinners/PulseLoader";

export default function CountriesListPage() {

    const { t } = useContext(TranslatorContext);
    const [data, setData] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [pagination, setPagination] = React.useState({});
    const [perPage, setPerPage] = React.useState(10);
    const [searchFilter, setSearchFilter] = React.useState('');

    
    const getAllDataAction = (page=1) => {
        getAllCountries(page, perPage,searchFilter).then((res) => {
            setData(res.data.data);
            setPagination(res.data.pagination);
        }).catch((error) => {
        }).finally(() => {
        });
    }

    const handlePageClick = (selected) => {
        getAllDataAction(selected.selected + 1);
    }
    
    useEffect(() => {
        getAllDataAction();
    }, [perPage,searchFilter]);
    const thead = [t("id"), t("name"), t("action")];


    if(loading) {
        return (
            <div className="mc-spinner">
                <img className="pattern" src="images/pattern.webp" alt="pattern" />
                <img className="favicon" src="images/logo.webp" alt="logo" />
                <div className="mc-spinner-group">
                    <h3>Loading</h3>
                    <PulseLoader 
                        color="#0857f5"
                        loading={loading} 
                        size={8} 
                    /> 
                </div>
            </div>
        );
    }else{
        return (
            <PageLayout>
                <Row>
                    <Col xl={12}>
                        <div className="mc-card">
                            <div className='mc-breadcrumb'>
                                <h3 className="mc-breadcrumb-title">{t('countries_list')}</h3>
                                {/* <ButtonComponent  className="btn btn-primary m-2" onClick={redirectToCreatePage}>{ t('Create New') }</ButtonComponent>*/}
                            </div>
                        </div>
                    </Col>
                    
                    <Col xl={12}>
                        <div className="mc-card">
                            
                            <Row xs={1} sm={2} xl={4}>
                                <Col>
                                    <LabelFieldComponent
                                        label={t('show_by')}
                                        option={["10", "20", "50", "100"] }
                                        labelDir="label-col"
                                        fieldSize="w-100 h-md"
                                        onChange= {(e)=>{
                                            setPerPage(e.target.value);
                                        }}
                                    />
                                </Col>
                                
                                
                                <Col>
                                    <LabelFieldComponent
                                        type="search"
                                        label={t('search_by')}
                                        placeholder={t('id') + ' / ' + t('name') }
                                        labelDir="label-col"
                                        fieldSize="w-100 h-md"
                                        onChange={(e) => {
                                            setSearchFilter(e.target.value);
                                        }}
                                    />
                                </Col>
                            </Row>
                            
                            {
                                data.length>0 &&
                                <CountriesTableComponent 
                                    thead={ thead }
                                    tbody={ data }
                                    refreshPage={ getAllDataAction }
                                />
                            }
                            
                            <PaginationComponent pagination={pagination} handlePageClick={handlePageClick}/>
                        </div>
                    </Col>
                </Row>
            </PageLayout>
        );
    }
    
}